import { useThemeUI } from 'theme-ui'
import { useLocomotiveScroll } from '@monolithmtl/locomotive-scroll'
import { useConditionalEffect } from '@react-hookz/web'

const ScrollBridge = () => {
  const { scroll } = useLocomotiveScroll()
  const { nativeDuration } = useThemeUI().theme?.transitions?.defaults ?? {}

  useConditionalEffect(
    () => {
      window.loco = { delay: nativeDuration, scroll }
    },
    undefined,
    [scroll]
  )

  return null
}

export default ScrollBridge
